<template>
  <div id="panelWrap" class="panel-wrap">
    <!-- CUSTOM LOGO -->
    <div class="panel-heading">
      <div class="row">
        <div class="col-md-12 text-center">
          <img
            src="../images/T1HHFgXXVeXXXXXXXX.png"
            alt="Logo-QQPay"
            class="img-responsive center-block"
          />
        </div>
      </div>
    </div>
    <!-- PANEL TlogoEMPLATE START -->
    <div class="panel panel-easypay">
      <!-- PANEL HEADER -->
      <div class="panel-heading">
        <h3>
          <small>方案一出现失败的客户请下载闲鱼扫码</small>
          <small>安装【闲鱼】辅助扫码（闲鱼需要登录），一次安装，终生受用，操作快捷，无需等待</small>
        </h3>
        <div class="money">
          <span style="font-size:30px" class="price">
            充值金额:
            <span id="cprice" class="price" style="font-size:30px">1.00</span>
          </span>
          <span style="font-size:30px" class="price">元</span>
        </div>
        <a class="payqrbtn" id="dopay" :href="orderInfo.jumpUrl">方案一:立即支付</a>
        <div class="money">
          <span class="payqrbtn" style="background-color: red;">
            <a style="color: #ffffff;" href="https://market.m.taobao.com/app/idleFish-F2e/2020-nowhere/pages/mobileDownload?wh_weex=true&callApp=1">没有闲鱼？戳我下载...</a>
          </span>
        </div>
        <div class="qrcode-warp">
          <div id="qrcodeCanvas" style="position:relative;">
            <div id="qrCode" ref="qrCodeDiv" style="width:210px;height:210px;margin:auto;"></div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <!--                <input type="button" id="btnDL" onclick="" value="立即支付" class="btn  btn-primary btn-lg btn-block" disabled>
        <a href="javascript:;" onclick="openLocation()" class="btn  btn-primary btn-lg btn-block" id="alipay">点击启动支付宝支付</a>
        <a href="javascript:;"  class="btn  btn-primary btn-lg btn-block" id="alipayBtn">点击启动支付宝支付</a>-->
      </div>

      <h3>
        <small>请用闲鱼APP扫上面这个二维码↑</small>
      </h3>
      <div class="time-item" style="padding-top: 10px">
        <strong id="hour_show">
          <s id="h"></s>{{hh}}时
        </strong>
        <strong id="minute_show">
          <s></s>{{MM}}分
        </strong>
        <strong id="second_show">
          <s></s>{{ss}}秒
        </strong>
      </div>
      <div class="panel-footer" style="display:none">
        <!-- SYSTEM MESSAGE -->
        <span id="Span1" class="warning" style="color:red;font-size:50px">
          <b>
            <small>
              请按下面步骤
              <br />1.请请截图保存二维码
              <br />2.打开支付宝，扫一扫
              <br />3.在相册中选择最新保存的二维码图片
            </small>
          </b>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
let axios = require("axios");
import QRCode from "qrcodejs2";
import Clipboard from "clipboard";

export default {
  name: "otherPay",
  data() {
    return {
      param: {},
      orderInfo: {},
      hh:'00',
      MM:'00',
      ss:'00'
    };
  },
  created() {
    var self = this;
    try {
      var param = this.$route.query;
      var data = [];
      for (const i in param) {
        var item = param[i];
        item = Base64.decode(decodeURI(item));
        if (item && item.indexOf("|") >= 0) {
          item = item.split("|")[0];
        }
        data.push(item);
      }
      var url = `${data[0]}/Facade/GetMecOrderInfo?orderid=${data[1]}&type=2`;
      axios
        .get(url)
        .then(function(response) { 
          if (
            response.data &&
            response.data.result &&
            response.data.code == 1
          ) {
            self.orderInfo = response.data.result;
            self.orderInfo.allMinute = self.orderInfo.timeAllCount / 60;
            self.orderInfo.isPay = false;
            self.$nextTick(function() {
              self.bindQRCode(self.orderInfo.qrCode);
            });
            self.setTimer(self.orderInfo.timeAllCount);
            new Clipboard(".btn").on("success", function() {
              alert("复制成功！");
            });
          } else {
            alert("请求失败");
          }
        })
        .catch(() => {
          alert("请求失败");
        });
    } catch (error) {
      alert("数据异常，请重新尝试");
    }
  },
  methods: {
    bindQRCode: function(url) {
      new QRCode(this.$refs.qrCodeDiv, {
        text: url,
        width: 210,
        height: 210,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    setTimer: function(time) {
      var self = this;
      self.hh=self.setDouString(parseInt(time/60/60))
      self.MM = self.setDouString(parseInt((time / 60)%60));
      self.ss = self.setDouString(time % 60);
      self.timer = setInterval(() => {
        time--;
        if (time == 0) {
            self.hh='00'
          self.MM = "00";
          self.ss = "00";
          clearInterval(self.timer);
        }
        self.hh=self.setDouString(parseInt(time/60/60))
        self.MM = self.setDouString(parseInt(time / 60));
        self.ss = self.setDouString(time % 60);
      }, 1000);
    },
    setDouString: function(num) {
      return num < 10 ? "0" + num : num;
    }
  }
};
</script>
<style>
@import url("../assets/pay.css");
html {
  font-size: 62.5%;
  font-family: "helvetica neue", tahoma, arial, "hiragino sans gb",
    "microsoft yahei", "Simsun", sans-serif;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td,
hr {
  margin: 0;
  padding: 0px 2px;
}

body {
  line-height: 1.333;
  font-size: 12px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-family: arial, "hiragino sans gb", "microsoft yahei", "Simsun",
    sans-serif;
}

input,
textarea,
select,
button {
  font-size: 12px;
  font-weight: normal;
}

input[type="button"],
input[type="submit"],
select,
button {
  cursor: pointer;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

address,
caption,
cite,
code,
dfn,
em,
th,
var {
  font-style: normal;
  font-weight: normal;
}

li {
  list-style: none;
}

caption,
th {
  text-align: left;
}

q:before,
q:after {
  content: "";
}

abbr,
acronym {
  border: 0;
  font-variant: normal;
}

sup {
  vertical-align: text-top;
}

sub {
  vertical-align: text-bottom;
}

fieldset,
img,
a img,
iframe {
  border-width: 0;
  border-style: none;
}

img {
  -ms-interpolation-mode: bicubic;
}

textarea {
  overflow-y: auto;
}

legend {
  color: #000;
}

a:link,
a:visited {
  text-decoration: none;
}

hr {
  height: 0;
}

label {
  cursor: pointer;
}

a {
  color: #328ce5;
}

a:hover {
  color: #2b8ae8;
  text-decoration: none;
}

a:focus {
  outline: none;
}

body,
.body {
  background: #f7f7f7;
  height: 100%;
  max-width: 640px;
  min-width: 300px;
  min-height: 100%;

  margin: 0 auto;
}

.mod-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  background: #fff;
}

.ico_log {
  display: inline-block;
  width: 130px;
  height: 38px;
  vertical-align: middle;
  margin-right: 7px;
}
/* 
.ico-1 {
  background: url("../images/logo_alipay.jpg") no-repeat;
  background-size: cover;
}

.ico-2 {
  background: url("../images/banner_qqpay.jpg") no-repeat;
}

.ico-3 {
  background: url("../images/logo_weixin.jpg") no-repeat;
  background-size: cover;
} */

.mod-title .text {
  font-size: 20px;
  color: #333;
  font-weight: normal;
  vertical-align: middle;
}
/* 
.mod-ct {
  min-width: 300px;
  max-width: 640px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  background: #fff url("../images/wave.png") top center repeat-x;
  text-align: center;
  color: #333;
  border: 1px solid #e5e5e5;
  border-top: none;
} */

.mod-ct .order {
  font-size: 20px;
  padding-top: 10px;
}

.mod-ct .amount {
  font-size: 42px;
  margin-top: 10px;
}

.mod-ct .qr-image {
  margin-top: 30px;
}

.mod-ct .qr-image img {
  width: 230px;
  height: 230px;
}

.mod-ct .detail {
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 10px;
}
/* 
.mod-ct .detail .arrow .ico-arrow {
  display: inline-block;
  width: 20px;
  height: 11px;
  background: url("../images/wechat-pay.png") -25px -100px no-repeat;
} */

.mod-ct .detail .detail-ct {
  display: none;
  font-size: 12px;
  text-align: right;
  line-height: 28px;
}

.mod-ct .detail .detail-ct dt {
  float: left;
}

.mod-ct .detail-open {
  border-top: 1px solid #e5e5e5;
}

.mod-ct .detail .arrow {
  padding: 6px 34px;
  border: 1px solid #e5e5e5;
}
/* 
.mod-ct .detail .arrow .ico-arrow {
  display: inline-block;
  width: 20px;
  height: 11px;
  background: url("../images/wechat-pay.png") -25px -100px no-repeat;
}

.mod-ct .detail-open .arrow .ico-arrow {
  display: inline-block;
  width: 20px;
  height: 11px;
  background: url("../images/wechat-pay.png") 0 -100px no-repeat;
} */

.mod-ct .detail-open .detail-ct {
  display: block;
}

.mod-ct .tip {
  margin-top: 20px;
  border-top: 1px dashed #e5e5e5;
  padding: 10px 0;
  position: relative;
}
/* 
.mod-ct .tip .ico-scan {
  display: inline-block;
  width: 56px;
  height: 55px;
  background: url("../images/wechat-pay.png") 0 0 no-repeat;
  vertical-align: middle;
  *display: inline;
  *zoom: 1;
} */

.mod-ct .tip .tip-text {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  margin-left: 23px;
  font-size: 16px;
  line-height: 28px;
  *display: inline;
  *zoom: 1;
}

/* .mod-ct .tip .dec {
  display: inline-block;
  width: 22px;
  height: 45px;
  background: url("../images/wechat-pay.png") 0 -55px no-repeat;
  position: absolute;
  top: -23px;
} */

.mod-ct .tip .dec-left {
  background-position: 0 -55px;
  left: -136px;
}

.mod-ct .tip .dec-right {
  background-position: -25px -55px;
  right: -136px;
}

.foot {
  text-align: center;
  margin: 30px auto;
  color: #888888;
  font-size: 12px;
  line-height: 20px;
  font-family: "simsun";
}

.copyRight {
  text-align: center;
  color: #888888;
  margin-bottom: 1px;
}

.copyRight a {
  color: #888888;
}

h1 {
  font-family: "微软雅黑";
  font-size: 15px;
  margin: 5px 0;
  padding-bottom: 2px;
  letter-spacing: 2px;
}

.time-item strong {
  background: #3ec742;
  color: #fff;
  line-height: 25px;
  font-size: 15px;
  font-family: Arial;
  padding: 0 10px;
  margin-right: 10px;
  border-radius: 5px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.item-title {
  background: none;
  line-height: 25px;
  font-size: 24px;
  padding: 0 10px;
  float: left;
}

.paybtn {
  display: inline-block;
  width: 100%;
  height: 80px;
  vertical-align: middle;
  padding-top: 10%;
  margin-right: 7px;
}

.submit_alipay {
  font-size: 16px;
  font-family: Arial;
  font-weight: normal;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #84bbf3;
  padding: 9px 76px;
  text-decoration: none;
  background: -moz-linear-gradient(center top, #79bbff 105%, #378de5 0%);
  background: -ms-linear-gradient(top, #79bbff 105%, #378de5 0%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#79bbff', endColorstr='#378de5');
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(105%, #79bbff),
    color-stop(0%, #378de5)
  );
  background-color: #79bbff;
  color: #ffffff;
  display: inline-block;
  text-shadow: 1px 1px 0px #528ecc;
  -webkit-box-shadow: 0px 0px 0px 0px #bbdaf7;
  -moz-box-shadow: 0px 0px 0px 0px #bbdaf7;
  box-shadow: 0px 0px 0px 0px #bbdaf7;
}
.submit_alipay:active {
  position: relative;
  top: 1px;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  width: 80%;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
.btn:focus,
.btn:active:focus,
.btn.active:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.btn:hover,
.btn:focus {
  color: #333;
  text-decoration: none;
}
.btn:active,
.btn.active {
  background-image: none;
  outline: 0;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  pointer-events: none;
  cursor: not-allowed;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
  opacity: 0.65;
}

.btn-primary {
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  color: #fff;
  background-color: #3071a9;
  border-color: #285e8e;
}
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  background-image: none;
}

.btn-primary .badge {
  color: #428bca;
  background-color: #fff;
}
.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.payqrbtn {
  width: 85%;
  background-color: #0897ff;
  color: #ffffff;
  font-weight: bold;
  font-size: 16px;
  display: block;
  height: 40px;
  line-height: 40px;
  margin: 20px auto;
}
small,
.small {
  font-size: 120% !important;
}
</style>